<template>
  <b-card no-body>
    <b-overlay :show="loading" rounded="sm" variant="light">
      <b-card-header>
        <div>
          <b-card-title class="mb-1">
            {{ $t("dashboard.incomingCall") }}
          </b-card-title>
        </div>
      </b-card-header>

      <b-card-body>
        <chartjs-component-line-chart
          :key="`comingConversatoionChart${key}`"
          :height="300"
          :data="chartjsData.lineChart.data"
          :options="chartjsData.lineChart.options"
          :plugins="plugins"
        />
      </b-card-body>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BCardSubTitle,
  BCardTitle,
  BButtonGroup,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import ChartjsComponentLineChart from "@/components/charts-components/ChartjsComponentLineChart.vue";
import chartjsData from "./chartjsData";
import Ripple from "vue-ripple-directive";
import moment from "moment-timezone";
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardSubTitle,
    BCardTitle,
    BButtonGroup,
    BButton,
    BOverlay,
    ChartjsComponentLineChart,
  },
  directives: {
    Ripple,
  },
  props: {
    chartData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    userData: function () {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName));
    },
  },
  watch: {
    currentLocale(value, oldValue) {
      if (oldValue && value && this.chartData?.data?.length) {
        this.mapChartData(this.chartData);
      }
    },
  },
  data() {
    return {
      chartjsData,
      plugins: [
        // to add spacing between legends and chart
        {
          beforeInit(chart) {
            /* eslint-disable func-names, no-param-reassign */
            chart.legend.afterFit = function () {
              this.height += 20;
            };
            /* eslint-enable */
          },
        },
      ],
      key: 1,
    };
  },
  methods: {
    mapChartData(data) {
      let labels = [];
      switch (data.period) {
        case "hour":
          for (let label of data.labels) {
            labels.push(
              moment(`${label}`)
                .tz(this.userData.origin)
                .locale(this.currentLocale)
                .format("hh:mm a")
            );
          }
          break;
        case "day":
          for (let label of data.labels) {
            labels.push(
              moment(`${label}`)
                .tz(this.userData.origin)
                .locale(this.currentLocale)
                .format("Do MMM")
            );
          }
          break;
        case "month":
          for (let label of data.labels) {
            labels.push(
              moment(`${label}`)
                .tz(this.userData.origin)
                .locale(this.currentLocale)
                .format("MMM YYYY")
            );
          }
          break;
        case "year":
          for (let label of data.labels) {
            labels.push(
              moment(`${label}`)
                .tz(this.userData.origin)
                .locale(this.currentLocale)
                .format("YYYY")
            );
          }
          break;
      }

      this.chartjsData.lineChart.data.labels = [...labels];
      this.chartjsData.lineChart.data.datasets[0].data = [...data.data];
      this.chartjsData.lineChart.data.datasets[0].label = this.$t(
        "dashboard.incomingConversation"
      );
      this.key++;
    },
  },
};
</script>
